import React from "react";

import Box from "./Box";
import InfoIcon from '@assets/images/info_icon.svg';


interface IInfoBox {
    message: string | React.ReactElement,
    testId?: string
}


export default function InfoBox({ message, testId }: IInfoBox) {
    return <Box message={message as string | React.ReactElement} icon={InfoIcon} bgColor={"#CCFFFB"} testId={testId}/>
}
